import ReactDOM from 'react-dom';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { configureStore } from 'redux/store';
import { AlertProvider, AlertOutlet } from 'react-bootstrap-hooks-alert';
import 'react-bootstrap-hooks-alert/dist/Alert.css';
import './index.scss';

ReactDOM.render(
    <Provider store={configureStore({})}>
        <AlertProvider timeouts={{ warning: 1500, success: 1500, danger: 1500 }}>
            <AlertOutlet />
            <App />
        </AlertProvider>
    </Provider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
